import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Result } from 'antd';
import { useAuth } from '../../../hooks/auth';
import { isOmieErp } from '../../../features/planning/engine';

/**
 * O orçamento do Sync foi migrado para as páginas de cenário do Planejamento: é lá que cada cenário é
 * criado, renomeado e editado, e é deles que o Gestão e o Studio leem o orçamento.
 */
const BudgetMovedNotice = ({ syncId, syncName, erp, onBack }) => {
  const navigate = useNavigate();
  const { canAccessPlanejamento } = useAuth();
  const canOpen = typeof canAccessPlanejamento === 'function' && canAccessPlanejamento();
  const company = syncName ? ` de ${syncName}` : '';
  const omieNote = isOmieErp(erp) ? ' A importação do orçamento da Omie também fica lá, no plano de cada cenário.' : '';

  return (
    <Result
      status="info"
      title="O orçamento agora fica no Planejamento"
      subTitle={canOpen
        ? `Os cenários${company} — inclusive Médio, Pessimista e Otimista, trazidos desta tela — são criados, renomeados e editados em Planejamento › Simulador. O Gestão e o Studio usam esses cenários como orçamento.${omieNote}`
        : `Os cenários${company} — inclusive Médio, Pessimista e Otimista, trazidos desta tela — continuam aparecendo como orçamento no Gestão e no Studio. Para editá-los, peça a liberação do módulo Planejamento.`}
      extra={[
        canOpen && (
          <Button key="open" type="primary" onClick={() => navigate(`/planejamento/simulador?syncId=${encodeURIComponent(syncId)}`)}>
            Abrir cenários no Planejamento
          </Button>
        ),
        <Button key="back" onClick={onBack}>Voltar</Button>,
      ].filter(Boolean)}
    />
  );
};

export default BudgetMovedNotice;
